import { useEffect, useState } from "react";

import { Tab } from "@headlessui/react";

import { scrollToBottomHeader } from "common/action-function/scrollToBottomHeader";

import Title from "components/atoms/Title";
import TabListNew from "components/molecules/TabListNew/index";

import CardPackage from "./CardPackage";

/** ========== */

const Component = ({ data, dataStatic, title }) => {
  const [defaultTab, setDefaultTab] = useState(0);
  const dataStaticPackage = dataStatic?.listPackage;
  const dataStaticEntitySuffix = dataStatic?.entitySuffix;
  const temp = dataStaticEntitySuffix?.reduce((totalID, currentValue) => {
    totalID.push(`${currentValue.guid}-package`);

    return totalID;
  }, []);

  const dataStaticFilter = (id) => {
    const result = dataStaticPackage.find((fruit) => fruit.id == id);

    return result;
  };

  const dataLink = `${dataStaticEntitySuffix[0]?.guid}-package`;

  useEffect(() => {
    if (dataLink.length > 0) {
      const url = window.location.href;

      setDefaultTab(
        temp.indexOf(url.split("#")[1]) < 0
          ? 0
          : temp.indexOf(url.split("#")[1])
      );
      if (url.search(`#${url.split("#")[1]}`) > 0) {
        const scrollToTable = document.getElementById("PriceTable");

        scrollToBottomHeader(scrollToTable);
      }
    }
  }, [temp, dataLink]);

  useEffect(() => {
    if (dataLink.length == 0) {
      setDefaultTab(0);
    }
  }, [dataLink]);

  const dataPackage = data.packages;
  const dataPackageFC = dataPackage.Packages.filter(
    (el) => el.id == 71 || el.id == 72
  );

  const dataSuffixFC = data.entitySuffix.EntityTypes.filter(
    (el) => el.id == 14 || el.id == 15
  );

  return (
    <div className="min-h-screen pt-10 lg:pt-20">
      <Title
        text={title}
        className={`bbc-title text-center ${
          dataStatic.description && dataStatic.description.length
            ? " mb-6"
            : " mb-6 lg:mb-10"
        }`}
      />
      <div id="PriceTable" className="mb-[60px] lg:mb-10">
        <TabListNew
          data={dataStaticEntitySuffix.map((item) => item.name)}
          activeTab={defaultTab}
          tabLinks={dataStaticEntitySuffix.map(
            (item) => `${item.guid}-package`
          )}
          tabListClass={{
            display: "block lg:flex flex-wrap justify-center",
            border: "border-0 lg:border border-[#B7B7B7]",
            background: "bg-transparent lg:bg-white",
            othersClass: "whitespace-nowrap ",
          }}
          tabClass={{
            tabColor:
              "text-bbc-neutral-600 border-bbc-neutral-600 bg-white lg:border-transparent",
            tabColorActive: "text-bbc-brand-500 border-bbc-brand-500 bg-white",
            othersClass: "mx-auto my-1 lg:m-0",
          }}
        >
          <Tab.Panels className="mt-6 w-full">
            {data?.entitySuffix?.EntityTypes?.map((entity, indexEntity) => {
              const dataPackages = data?.packages?.Packages.filter(
                (item) => item.entity_type_id == entity.id
              );

              return (
                <Tab.Panel key={indexEntity} as="div">
                  <div className="hidden lg:block">
                    <div className="row justify-center">
                      {dataPackages.length === 3
                        ? dataPackages
                            .filter((item) => item.id !== 65 && item.id !== 79)
                            .map((card, index) => {
                              const title = card?.PackageType?.name;

                              return (
                                <div key={index} className="lg:col-5 xl:col-4">
                                  <CardPackage
                                    entityId={card.entity_type_id}
                                    data={dataStaticFilter(card.id)}
                                    dataEntitySuffix={data.entitySuffix}
                                    dataPackage={data.packages}
                                    index={index}
                                    kind={title}
                                    price={card?.Services[0].Fee.value}
                                    dataSuffix={{
                                      id: 244,
                                      name: data?.entitySuffix?.sub_name,
                                      suffixData:
                                        data?.entitySuffix?.EntityTypes[
                                          indexEntity
                                        ],
                                    }}
                                  />
                                </div>
                              );
                            })
                        : dataPackageFC.map((card, index) => {
                            const title = card?.PackageType?.name;

                            return (
                              <div key={index} className="lg:col-5 xl:col-4">
                                <CardPackage
                                  entityId={card.entity_type_id}
                                  data={dataStaticFilter(card.id)}
                                  dataEntitySuffix={data.entitySuffix}
                                  dataPackage={data.packages}
                                  index={index}
                                  kind={title}
                                  price={card?.Services[0].Fee.value}
                                  dataSuffix={{
                                    id: 244,
                                    name: data?.entitySuffix?.sub_name,
                                    suffixData: dataSuffixFC[index],
                                  }}
                                />
                              </div>
                            );
                          })}
                    </div>
                  </div>
                  <div className="block w-full lg:hidden">
                    <TabListNew
                      data={
                        dataStaticEntitySuffix[indexEntity] &&
                        dataStaticEntitySuffix[indexEntity].tabTitle.map(
                          (item) => item
                        )
                      }
                    >
                      <Tab.Panels className="mx-auto mt-6 w-full max-w-[350px]">
                        {dataPackages.length === 3
                          ? dataPackages
                              .filter(
                                (item) => item.id !== 65 && item.id !== 79
                              )
                              .map((card, index) => {
                                const title = card?.PackageType?.name;

                                return (
                                  <Tab.Panel
                                    key={index}
                                    className="focus:outline-none focus:outline-0 focus:ring-0"
                                    as="div"
                                  >
                                    <CardPackage
                                      entityId={card.entity_type_id}
                                      data={dataStaticFilter(card.id)}
                                      dataEntitySuffix={data.entitySuffix}
                                      dataPackage={data.packages}
                                      index={index}
                                      kind={title}
                                      price={card?.Services[0].Fee.value}
                                      dataSuffix={{
                                        id: 244,
                                        name: data?.entitySuffix?.sub_name,
                                        suffixData:
                                          data?.entitySuffix?.EntityTypes[
                                            indexEntity
                                          ],
                                      }}
                                    />
                                  </Tab.Panel>
                                );
                              })
                          : dataPackageFC.map((card, index) => {
                              const title = card?.PackageType?.name;

                              return (
                                <Tab.Panel
                                  key={index}
                                  className="focus:outline-none focus:outline-0 focus:ring-0"
                                  as="div"
                                >
                                  <CardPackage
                                    entityId={card.entity_type_id}
                                    data={dataStaticFilter(card.id)}
                                    dataEntitySuffix={data.entitySuffix}
                                    dataPackage={data.packages}
                                    index={index}
                                    kind={title}
                                    price={card?.Services[0].Fee.value}
                                    dataSuffix={{
                                      id: 244,
                                      name: data?.entitySuffix?.sub_name,
                                      suffixData: dataSuffixFC[index],
                                    }}
                                  />
                                </Tab.Panel>
                              );
                            })}
                      </Tab.Panels>
                    </TabListNew>
                  </div>
                </Tab.Panel>
              );
            })}
          </Tab.Panels>
        </TabListNew>
      </div>
    </div>
  );
};

export default Component;
